import { render, staticRenderFns } from "./scvsTable.vue?vue&type=template&id=94605502&scoped=true&"
import script from "./scvsTable.vue?vue&type=script&lang=js&"
export * from "./scvsTable.vue?vue&type=script&lang=js&"
import style0 from "./scvsTable.vue?vue&type=style&index=0&id=94605502&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94605502",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VDataTable,VTooltip})
